const MultiTabError = (props: any) => (
  <div className="p-3 col-1 border-s border-gray-300 flex h-screen">
    <div className="relative m-auto text-red-600 text-center items-center justify-center text-lg">
      既に「らくらくデコルーム」のリンクを別のタブで開いています。
    </div>
  </div>
);

export default MultiTabError